import { PurchaseableSubTier, PurchaseableTier } from '@sparemin/api-sdk';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import Infobox from 'components/Infobox';
import LinkButton from 'components/LinkButton';
import { onCheckoutModalChangePlan } from 'redux/modules/mixpanel';
import { replaceModal } from 'redux/modules/modal';
import { useAddBillingCycleModal } from './AddBillingCycleModalContext';
import { block, getInfoBoxConfig } from './utils';

export interface TierInfoboxProps {
  tier: PurchaseableTier;
  subtier?: PurchaseableSubTier;
}

const TierInfobox: React.FC<TierInfoboxProps> = ({ tier, subtier }) => {
  const dispatch = useDispatch();
  const { allowTierSelection } = useAddBillingCycleModal();

  const { icon, theme, displayName } = getInfoBoxConfig(tier, subtier) ?? {};

  const handleSelectAnother = () => {
    dispatch(onCheckoutModalChangePlan);
    dispatch(
      replaceModal({
        name: 'TierSelection',
      }),
    );
  };

  return (
    <Infobox className={block('tier-infobox')} {...{ icon, theme }}>
      {displayName}
      {allowTierSelection && (
        <>
          {' '}
          (
          <LinkButton
            className={block('tier-infobox-link')}
            onClick={handleSelectAnother}
          >
            select another
          </LinkButton>
          )
        </>
      )}
    </Infobox>
  );
};

export default TierInfobox;
